/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2023 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
  'use strict';

  // Use behaviors with context variable.
  Drupal.behaviors.insuranceSelect = {
    attach: function (context) {
      // Insurances accepted list
      // This may need to be modified to be more general in drupal since it is tracking
      // against a specific value
      $(document).on('select change', '#insurance-select', function () {
        let $this = $(this);
        let $selectList = $this.siblings(".insurance-select__list");
        let $selectOptions = $('li', $selectList);
        let $message = $this.siblings(".insurance-select__message");

        let $selectValue = $this.val();

        if ($selectValue !== "insurance-select") {
          $selectList.slideDown();
          $message.addClass('is-hidden');
          $selectOptions.hide();
          $selectOptions.filter('.' + $selectValue).show();
        }
        else {
          $selectList.slideUp();
          $message.removeClass('is-hidden');
        }

      });

    }
  };

})(jQuery);
